import ValidatePage from '@/router/modules/methods/validate'
import clear_all_videos from "@/router/modules/methods/clear_all_videos";

export default {
    path: '/add-ending-select',
    name: 'Add-Ending-Select',
    component: () => import('@/views/add_ending_select/index.vue'),
    meta: {
        title: 'Добавление концовки',
        forVisitors: true
    },
    beforeEnter: async (to, from, next) => {
        await clear_all_videos()
        await ValidatePage(next)
    }
}